import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import style from '@aytm/app/stats/page/data-quality-report/styles/sections/SurveyDesignSlider.module.scss'

// Five aytm smiley faces (worst → best), picked by which fifth of the 0..max range the score lands in.
const FACE_ICONS = [
  'icon-aytmfd-smile-angry',
  'icon-aytmfd-smile-sad',
  'icon-aytmfd-smile-indifferent',
  'icon-aytmfd-smile-happy',
  'icon-aytmfd-smile-excited'
]

const faceFor = pct => FACE_ICONS[Math.min(FACE_ICONS.length - 1, Math.floor(pct * FACE_ICONS.length))]

// Same stops as the gradient track; the face is tinted to the exact color under the marker.
const STOPS = [
  { at: 0, rgb: [0xd0, 0x00, 0x00] },
  { at: 0.25, rgb: [0xff, 0x7d, 0x00] },
  { at: 0.5, rgb: [0xfc, 0xf4, 0x39] },
  { at: 0.72, rgb: [0x5c, 0xdb, 0xbe] },
  { at: 1, rgb: [0x49, 0xab, 0xfd] }
]

const colorAt = pct => {
  const p = Math.max(0, Math.min(1, pct))
  const hiIndex = Math.max(
    1,
    STOPS.findIndex(s => s.at >= p)
  )
  const lo = STOPS[hiIndex - 1]
  const hi = STOPS[hiIndex]
  const t = hi.at === lo.at ? 0 : (p - lo.at) / (hi.at - lo.at)
  const [r, g, b] = lo.rgb.map((c, i) => Math.round(c + (hi.rgb[i] - c) * t))
  return `rgb(${r}, ${g}, ${b})`
}

const SurveyDesignSlider = ({ score, max }) => {
  const pct = Math.max(0, Math.min(1, (score ?? 0) / max))

  // Slide the marker in from the left edge to the score position on mount.
  const [pos, setPos] = useState(0)
  useEffect(() => setPos(pct), [pct])

  return (
    <div data-testid="stat-dqr-survey-design-slider" className={style.slider}>
      <div data-testid="stat-dqr-survey-design-marker" className={style.marker} style={{ left: `${pos * 100}%` }}>
        <span data-testid="stat-dqr-survey-design-score" className={style.score}>
          {score == null ? '—' : score}
        </span>
        <i className={`${style.face} ${faceFor(pct)}`} style={{ color: colorAt(pct) }} />
      </div>
      <div className={style.track} />
      <div className={style.scale}>
        <span>0</span>
        <span>{max}</span>
      </div>
    </div>
  )
}

SurveyDesignSlider.displayName = 'SurveyDesignSlider'
SurveyDesignSlider.propTypes = { score: PropTypes.number, max: PropTypes.number }
SurveyDesignSlider.defaultProps = { max: 500 }
export default SurveyDesignSlider
